function equalizeDescriptionsHeight() {
  // Get all descriptions within .team-members
  const columns = document.querySelectorAll('.team-members .rbsv2-columns__column');
  const descriptions = Array.from(columns).map(col => 
    col.querySelector('.rbsv2-columns__column-description')
  ).filter(Boolean);
  
  if (descriptions.length === 0) return;
  
  // Find the tallest description
  let maxHeight = 0;
  descriptions.forEach(desc => {
    desc.style.height = 'auto'; // Reset height to get actual height
    const height = desc.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });
  
  // Set all descriptions to the same height (tallest one)
  descriptions.forEach(desc => {
    desc.style.height = maxHeight + 'px';
  });
  
  console.log(`Set all ${descriptions.length} descriptions to height: ${maxHeight}px`);
}

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
  equalizeDescriptionsHeight();
  
  // Also run on window load to ensure images are loaded
  window.addEventListener('load', function() {
    equalizeDescriptionsHeight();
  });
});

